import React from "react";
import  { useState, useEffect } from 'react';
import './classes/ManageProducts.css';
import { useNavigate,useParams,useLocation } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import { configData } from "../config";
import { Link } from '@mui/material';
import { Helmet } from "react-helmet";
import Loading from './Loading';

const ManageProducts = () => {

    const columns = [
        {
            field: 'productName',
            headerName: 'Product Name',
            headerClassName: 'product-name-header',
            // minWidth: 200, 
            flex:2,  
            sortable: false,
            filterable: false,
        },
        {
            field: 'productSku',
            headerName: 'Product Sku',
            headerClassName: 'product-sku-header',
            // minWidth: 200, 
            flex:2,  
            sortable: false,
            filterable: false,
        },
        {
            field: 'relatePackage',
            headerName: 'Relate Package',
            headerClassName: 'relate-package-header',
            // minWidth: 100, 
            flex:1,  
            sortable: false,
            filterable: false,
        },
        {
            field: 'price',
            headerName: 'Price',
            headerClassName: 'price-header',
            // minWidth: 100, 
            flex:1,  
            sortable: false,
            filterable: false,
        },
        {
            field: 'price1',
            headerName: 'Price 1',
            headerClassName: 'price1-header',
            // minWidth: 100, 
            flex:1,  
            sortable: false,
            filterable: false,
        },
        {
            field: 'price2',
            headerName: 'Price 2',
            headerClassName: 'price2-header',
            // minWidth: 100, 
            flex:1,  
            sortable: false,
            filterable: false,
        },
        {
            field: 'type',
            headerName: 'Type',
            headerClassName: 'type-header',
            // minWidth: 130, 
            flex:1.25,  
            sortable: false,
            filterable: false,
        },
        {
            field: 'status',
            headerName: 'Status',
            headerClassName: 'status-header',
            // minWidth: 120, 
            flex:1.25,  
            sortable: false,
            filterable: false,
        },
        {
            field: 'operations',
            headerName: 'Operations',
            headerClassName: 'super-app-theme--header',
            // minWidth: 150, 
            flex:1.25,  
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <>
                    <Link href={params.row.edit_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
                        {params.row.linkText || 'Edit'}
                    </Link>
                    <span>&nbsp;|&nbsp;</span>
                    <Link href={params.row.delete_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
                        {params.row.linkText || 'Delete'}
                    </Link>
                </>
            ),
        },
    ];

    const productType = [
        { value: "1", label: "Course" },
        { value: "2", label: "Agent Initiation" },
        { value: "3", label: "Scout Initiation" },
        { value: "4", label: "Miscellaneous" },
        { value: "5", label: "Reenroll" },
        { value: "6", label: "Renewal" },
        { value: "7", label: "Conference" },
        { value: "8", label: "Package" },
        { value: "9", label: "Apparel" },
    ];

    const relateCategories = [
        { value: "8", label: "Backpacks" },
        { value: "6", label: "Hats" },
        { value: "7", label: "Hoodies" },
        { value: "5", label: "Jackets" },
        { value: "4", label: "Long-Sleeve Shirts" },
        { value: "3", label: "Short-Sleeve Shirts" },
    ];

    const [isLoading, setIsLoading] = useState(true);

    const [rows, setRows] = React.useState([]);
    const [rowCount, setRowCount] = React.useState(0);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = React.useState([]);
    const [filterModel, setFilterModel] = React.useState({ items: [] });
    const [categories, setcategories] = useState([])
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const location  = useLocation();
    const[successMessage,setSuccess] = useState('');
     const Message = location.state?.message; // Access the message
    const [formData, setformData] = useState({
        product_sku: '',
        product_title:'',
        product_type: '',
        relate_categories: '',
        product_status: '1'
    });

    const [appliedFormData, setAppliedFormData] = useState({
        product_sku: '',
        product_title:'',
        product_type: '',
        relate_categories: '',
        product_status: '1'
    });

    const handleChange = (event) => {
        const { name, value } = event.target;
        setformData({ ...formData, [name]: value });
    };

    useEffect(() => {
        Promise.all([
            retrievecategorylist()
        ])
        .then(() => {
     
        setIsLoading(false);
        })
     
    },[]);
    useEffect(() => {
      if (Message) {
        setSuccess(Message);
        window.history.replaceState({}, '');
      }
    }, [Message, location.state]);
    async function retrievecategorylist() {
    
       
            const response = await fetch(
                 app_url+'smwwcommerceproduct/getapparelcategoryparentlist',
                {
                    method: "GET",
  
                    headers: {
                    'Content-Type': 'application/json',
                    },
                }
            )           
            const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
                setcategories(responsedata.data.result);
            }
       
    }
React.useEffect(() => {
    const fetchData = async () => {
      // Simulate API call to your server
      // In a real application, replace this with your actual fetch logic
       try {
        setIsLoading(true);
      const response = await fetch(app_url+'smwwcommerceproduct/getlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
          sortModel,
          filterModel,
        //   formData:formData
        formData:appliedFormData,
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
      //setSuccess('');
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
    };
    

    fetchData();
  }, [paginationModel, sortModel, filterModel,appliedFormData]); // Re-fetch data when these change
const handleSubmit = async (e) => {
  e.preventDefault();
   setPaginationModel({
                page: 0,
                pageSize: 50,
                });
                setAppliedFormData({ ...formData });
  try {
     setIsLoading(true);
const response = await fetch(app_url+'smwwcommerceproduct/getlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: 0,
          pageSize: 50,
          sortModel,
          filterModel,
          formData:formData
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
      setSuccess('');
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
  
}; 

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main" className="manage-products-main">
                    <Helmet><title>Product List</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <h1>Product List</h1>
                        <div className="manage-products-container">
                            {successMessage && (
                        <div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successMessage}
                        </div>
                        )}
                            <form onSubmit={handleSubmit}>
                                <label>Product SKU</label>
                                <input type="text" id="product_sku" name="product_sku" value={formData.product_sku} onChange={handleChange} />

                                <label>Product Name</label>
                                <input type="text" id="product_title" name="product_title" value={formData.product_title} onChange={handleChange} />

                                <label>Product Type</label>
                                <select 
                                    id="product_type" 
                                    name="product_type"
                                    value={formData.product_type}
                                    onChange={handleChange}
                                >
                                    <option value="">-Select-</option>
                                    {productType.map((type) => (
                                        <option key={type.value} value={type.value}>
                                        {type.label}
                                        </option>
                                    ))}
                                </select>

                                <label>Select Categories</label>
                                <select 
                                    id="relate_categories" 
                                    name="relate_categories"
                                    value={formData.relate_categories}
                                    onChange={handleChange}
                                >
                                    <option value="">-Select-</option>
                                    {categories.map((category) => (
                                        <option key={category.value} value={category.value}>
                                        {category.label}
                                        </option>
                                    ))}
                                </select>
                                <label>Product Status</label>
                                <select 
                                    id="product_status" 
                                    name="product_status"
                                    value={formData.product_status}
                                    onChange={handleChange}
                                >
                                <option value="1">Active</option>
                                <option value="2">Disabled</option>
                                <option value="3">Archive</option>
                                </select>
                                <div style={{marginLeft: "5px", marginTop: "10px"}}>
                                    <input 
                                        type="submit" 
                                        name="apply" 
                                        value="Apply" 
                                        style={{height: "30px", marginRight: "10px", width: "115px"}} 
                                        className="form-submit"  
                                        // onClick={handleSubmit}
                                    />
                                    <a href="/admin/smww-commerce/product-list">
                                        <input 
                                            type="button" 
                                            style={{height: "30px", width: "115px"}} 
                                            name="op" 
                                            value="Clear" 
                                            className="form-submit" 
                                        />
                                    </a> 
                                </div>
                            </form>
                            <div>
                                <a href="/admin/smww-commerce/product-create">Add a Product</a>
                                <span style={{marginLeft: "5px", marginRight: "5px"}}>|</span>
                                <a href="/admin/smww-commerce/product-package-create">Add a Package</a>
                                <span style={{marginLeft: "5px", marginRight: "5px"}}>|</span>
                                <a href="/admin/smww-commerce/product-package-list">Package List</a>
                            </div>
                            <br />
                            <div className="manage-products-table" style={{ width: '100%' }}>
                                <DataGrid
                                    autoHeight={true}
                                    rows={rows}
                                    columns={columns}
                                    rowCount={rowCount}
                                    getRowHeight={()=>'auto'} 
                                    paginationMode="server"
                                    sortingMode="server"
                                    filterMode="server"
                                    paginationModel={paginationModel}
                                    onPaginationModelChange={setPaginationModel}
                                    sortModel={sortModel}
                                    onSortModelChange={setSortModel}
                                    filterModel={filterModel}
                                    onFilterModelChange={setFilterModel}
                                    pageSizeOptions={[5, 10, 25,50]} 
                                    pageSize={50}
                                    getRowId={() => crypto.randomUUID()}
                                    //  hideScrollbar={true}     
                                />
                            </div>
                        </div>
                    </div>
                    <div className="right"></div>
                </div>
            )}
        </>
    );
};
export default ManageProducts;